import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

interface Customer {
  customer_id: string;
  customer_name: string;
  assigned_date: string;
  survey_status: string;
}

interface EmployeeAssignment {
  employee_id: string;
  employee_name: string;
  employee_code: string;
  customers: Customer[];
  customer_count: number;
  completed_count: number;
  pending_count: number;
}

interface SurveyInfo {
  survey_id: string;
  survey_number: string;
  survey_title: string;
  survey_description: string;
}

@Component({
  selector: 'app-assignment-detail',
  templateUrl: './assignment-detail.component.html',
  styleUrls: ['./assignment-detail.component.css']
})
export class AssignmentDetailComponent implements OnInit {
  surveyInfo: SurveyInfo | null = null;
  employeeAssignments: EmployeeAssignment[] = [];
  loading = false;
  error = '';

  private baseUrl = 'https://test.shajipaints.com/dev/FactoryCustomerSurvey';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const surveyId = this.route.snapshot.paramMap.get('id');
    if (surveyId) {
      this.loadAssignmentDetails(surveyId);
    } else {
      this.error = 'Survey ID not provided';
    }
  }

  loadAssignmentDetails(surveyId: string): void {
    this.error = '';

    this.http.get<any>(`${this.baseUrl}/viewAssignments/${surveyId}`).subscribe({
      next: (response) => {
        if (response.success) {
          this.surveyInfo = response.survey;
          this.employeeAssignments = response.data || [];
        } else {
          this.error = 'Failed to load assignment details';
        }
      },
      error: (err) => {
        console.error('Error loading assignment details:', err);
        this.error = 'Error loading assignment details. Please try again.';
      }
    });
  }

  goBack(): void {
    this.router.navigate(['admin/customer-survey-menu/assignment-listing']);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  getStatusClass(status: string): string {
    return status === 'Conducted' ? 'status-completed' : 'status-pending';
  }
}